import { getRuntimeEnvironment, readRuntimeConfig } from './runtime-config'

export const apiVersion = '/v1'
export const apiVersionV2 = '/v2'

/*
* allow to change API_URL in runtime
* how to deploy frontend branch - https://elopay.atlassian.net/wiki/spaces/EPD/pages/2457862151/How+to+deploy+frontend+branch
* */
const API_URL = process.env.NEXT_PUBLIC_API_URL
const NEXT_PUBLIC_API_CLIENT_URL = readRuntimeConfig('NEXT_PUBLIC_API_CLIENT_URL')
const NEXT_PUBLIC_WEB_HOST = readRuntimeConfig('NEXT_PUBLIC_WEB_HOST')
const SSR_API_URL = NEXT_PUBLIC_API_CLIENT_URL ?? API_URL

const apis = {
  test: 'https://api.test.myablefy.com',
  staging: 'https://api-cdn.staging.myablefy.com',
  uat: 'https://api-cdn.uat.myablefy.com',
  production: 'https://api-cdn.myablefy.com',
} as const

export const apiEndpoints = {
  test: apis.test,
  development: NEXT_PUBLIC_API_CLIENT_URL || apis.staging,
  staging: NEXT_PUBLIC_API_CLIENT_URL || apis.staging,
  uat: NEXT_PUBLIC_API_CLIENT_URL || apis.uat,
  production: NEXT_PUBLIC_API_CLIENT_URL || apis.production,
} as const

export const apiEndpointsSSR = {
  development: SSR_API_URL ?? apis.staging,
  staging: SSR_API_URL ?? apis.staging,
  uat: SSR_API_URL ?? apis.uat,
  production: SSR_API_URL ?? apis.production,
} as const

const apiEndpointsSSRDefaults = {
  development: apis.staging,
  staging: apis.staging,
  uat: apis.uat,
  production: apis.production,
} as const

export const getShopApiEndpointSSR = () => {
  const environment = getRuntimeEnvironment() as keyof typeof apiEndpointsSSRDefaults
  const runtimeApiUrl = readRuntimeConfig('NEXT_PUBLIC_API_CLIENT_URL')
  const legacyApiUrl = process.env.NEXT_PUBLIC_API_URL || API_URL

  return runtimeApiUrl || legacyApiUrl || apiEndpointsSSRDefaults[environment]
}

export const apiEndpointsCommunity = {
  development: 'https://community.staging.myablefy.com',
  staging: 'https://community.staging.myablefy.com',
  uat: 'https://community.uat.myablefy.com',
  production: 'https://community.myablefy.com',
} as const

export const webProtocols = {
  development: 'http',
  staging: 'https',
  uat: 'https',
  production: 'https',
} as const

export const webHosts = {
  test: NEXT_PUBLIC_WEB_HOST || 'staging.myablefy.com',
  development: NEXT_PUBLIC_WEB_HOST || 'staging.myablefy.com',
  staging: NEXT_PUBLIC_WEB_HOST || 'staging.myablefy.com',
  uat: NEXT_PUBLIC_WEB_HOST || 'uat.myablefy.com',
  production: NEXT_PUBLIC_WEB_HOST || 'myablefy.com',
} as const

export const getShopWebHost = () => {
  const environment = getRuntimeEnvironment() as keyof typeof webHosts

  return readRuntimeConfig('NEXT_PUBLIC_WEB_HOST') || webHosts[environment]
}

export const marketingWebHosts = {
  test: 'staging.ablefy.io',
  development: 'staging.ablefy.io',
  staging: 'staging.ablefy.io',
  uat: 'uat.ablefy.io',
  production: 'ablefy.io',
} as const

export const facebookAppId = '1512219545743496'

export const cookiesDomains = {
  development: 'localhost',
  staging: '.staging.myablefy.com',
  uat: '.uat.myablefy.com',
  production: '.myablefy.com',
}

export const reCaptchaKey = '6LfwMlgfAAAAAM4zLLAcEQVRXCq0fLxloNoZIyIk'

export const amplifyConfig = {
  development: {
    aws_appsync_graphqlEndpoint: 'https://77nhynlszjcidn62nual5aqd2a.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AWS_LAMBDA',
  },
  staging: {
    aws_appsync_graphqlEndpoint: 'https://77nhynlszjcidn62nual5aqd2a.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AWS_LAMBDA',
  },
  uat: {
    aws_appsync_graphqlEndpoint: 'https://4n7tjdjbengojpbb55zrf7mkxu.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AWS_LAMBDA',
  },
  production: {
    aws_appsync_graphqlEndpoint: 'https://zej32h344bg2dbvmbggdpzyefu.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AWS_LAMBDA',
  },
} as const

export const sentryConfig = {
  development: {
    publicDsn: ''
  },
  staging: {
    publicDsn: 'https://aafd9266a0544f6eb19d5fa618912e7e@o407470.ingest.sentry.io/6599603'
  },
  uat: {
    publicDsn: ''
  },
  production: {
    publicDsn: 'https://aafd9266a0544f6eb19d5fa618912e7e@o407470.ingest.sentry.io/6599603'
  }
} as const

export const sentryConfigCabinets = {
  development: 'https://966ff7d740f658a54bdb97588eefba89@o407470.ingest.sentry.io/4505679922790400',
  staging: 'https://966ff7d740f658a54bdb97588eefba89@o407470.ingest.sentry.io/4505679922790400',
  uat: 'https://966ff7d740f658a54bdb97588eefba89@o407470.ingest.sentry.io/4505679922790400',
  production: 'https://966ff7d740f658a54bdb97588eefba89@o407470.ingest.sentry.io/4505679922790400',
} as const

export const SDK_KEY = 'b136e032-69dc-4afb-8e75-29bb70da1971'

export const EVER_AFTER_MOBILE_LOCATION_ID = '879279b8-7212-4757-b47e-bc780295d23b'

export const metabaseHosts = {
  development: process.env.METABASE_HOST || 'https://metabase.ablefy.tech',
  staging: process.env.METABASE_HOST || 'https://metabase.ablefy.tech',
  uat: process.env.METABASE_HOST || 'https://metabase.ablefy.tech',
  production: process.env.METABASE_HOST || 'https://metabase.ablefy.tech',
} as const

export const APP_STATSIG_CLIENT_KEYS = {
  development: 'client-OUgE2LrzmwKjqSt4Maav3r3XvVmVAiUssqosav3kTe0', // pragma: allowlist secret
  staging: 'client-lGaAYkwWRVxOqMhAzHMJ19qlGESx2UzMraBzOzF7CUd', // pragma: allowlist secret
  uat: 'client-LuhxWFubef8Z8tHQobifLbucbCDr1OyMORfVyIKUxk7', // pragma: allowlist secret
  production: 'client-MDqfoB0EqHFyp9rdERFVRCFqXJagTthESjex4nC6Xs8', // pragma: allowlist secret
}

export const PERSONA_ENVIRONMENT_IDS = {
  development: 'env_B5thU9tRYFVZ2UdJCyTua8vKrjau', // pragma: allowlist secret
  staging: 'env_B5thU9tRYFVZ2UdJCyTua8vKrjau', // pragma: allowlist secret
  uat: 'env_B5thU9tRYFVZ2UdJCyTua8vKrjau', // pragma: allowlist secret
  production: 'env_neMQ56uXhUP2uzwG5kbxwgnCrBwM', // pragma: allowlist secret
}
